import React from "react";
import ContentModerationView from "@/components/contentModeration/ContentModerationView";
import { breadcrumb_key } from "@/constants/translation/common.translation";
import { contentModeration } from "@/libs/routes";

/**
 * Content Moderation > Communities: basic details of one item with Deactivate / Reactivate / Delete.
 */
const CommunitiesModerationView = () => (
  <ContentModerationView sectionKey="communities" />
);

CommunitiesModerationView.breadCrumbArray = [
  {
    name: breadcrumb_key.contentModeration.communities.list,
    pathname: contentModeration.communities.list,
    active: false,
  },
  {
    name: breadcrumb_key.contentModeration.communities.view,
    pathname: "",
    active: true,
  },
];

export default CommunitiesModerationView;
